import styled from 'styled-components';
import {media} from '@prima-afp/prima-ui-design-system/dist/media';

export const ContainerMiniLanding = styled.div`
    width: 100%;
    max-width: 690px;
    gap: 0px;
    padding-top:64px;
    .content{
        padding: 32px;
        border-radius: 24px;
        border: 1.5px solid var(--Border-White-Lighter, rgba(231, 231, 232, 1));
        .titleMain{
            padding-bottom: 8px;
        }
        .titleText{
            Padding-bottom: 24px;
        }
        .input{
            max-width: 303px;
        }

    }
    .contentButton{
        display: flex;
        justify-content: end;
        Padding-top: 32px;
        button{
            width: 202px;
            padding: 16px 0px;
        }
    }

            
    ${media.xs} {
    max-width: auto;
    padding: 40px 23.5px 0px 23.5px;
    .contentButton{
        button{
            width: 100%;
        }
    }
    .content {
        padding: 32px 20px;
        .titleMain{
            max-width: 272px;
        }
        .text{
            Padding-bottom: 12px;
        }
        .input{
            max-width: 100%; 
            min-width: auto;           
        }
        .input * {
            min-width: auto !important;
        }
    }

    }
`